import { makeStyles } from '@branchjs/neo-components';

export const useStyles = makeStyles({
  menu: {
    '& .MuiTypography-h2': {
      fontSize: 16,
      fontWeight: 600,
    },
  },
});
